<template>
  <form class="register__wrapper" @submit="handleSubmit">
    <div class="form__error" v-if="errors.global">{{errors.global}}</div>
    <div class="form__row">
      <div class="form__col-1-3">
        <input type="text" autocomplete="given-name" @blur="checkTextOnly('firstName', 'account', true)" v-model="form.account.firstName" placeholder="Imię*"/>
        <div class="form__row-error" v-if="errors.firstName"> {{ errors.firstName }} </div>
      </div>
      <div class="form__col-1-3">
        <input type="text" autocomplete="family-name" @blur="checkTextOnly('lastName', 'account', true)" v-model="form.account.lastName" placeholder="Nazwisko*"/>
        <div class="form__row-error" v-if="errors.lastName"> {{ errors.lastName }} </div>
      </div>
      <div class="form__col-1-6">
        <input type="number" autocomplete="off" @blur="checkNPWZ" v-model="form.specialist.NPWZ" placeholder="Nr PWZ*"/>
        <div class="form__row-error" v-if="errors.NPWZ"> {{ errors.NPWZ }} </div>
      </div>
      <div class="form__col-1-6">
        <input type="tel" autocomplete="tel" @blur="checkPhoneNumber" v-model="form.account.phoneNumber" placeholder="Tel. komórkowy" />
        <div class="form__row-error" v-if="errors.phoneNumber"> {{ errors.phoneNumber }} </div>
      </div>
    </div>
    <div class="form__row">
      <div class="form__col-1-3">
        <Select v-model="form.address.voivodeship" @change="checkRequired('voivodeship')" :options="voivodeships" :label="'Województwo'" :required="true">
        </Select>
        <div class="form__row-error" v-if="errors.voivodeship"> {{ errors.voivodeship }} </div>
      </div>
      <div class="form__col-1-3">
        <input type="text" autocomplete="address-level2" @blur="checkTextOnly('city', 'address')" v-model="form.address.city" placeholder="Miasto" />
        <div class="form__row-error" v-if="errors.city"> {{ errors.city }} </div>
      </div>
      <div class="form__col-1-3">
        <input type="text" autocomplete="off" @blur="checkmedicalCenter" v-model="form.specialist.medicalCenter" placeholder="Nazwa ośrodka" />
        <div class="form__row-error" v-if="errors.medicalCenter"> {{ errors.medicalCenter }} </div>
      </div>
    </div>

    <h3 class="register__title">Dane do logowania</h3>
    <div class="form__row">
      <div class="form__col-1-3">
        <input type="text" autocomplete="email" @blur="checkEmail" v-model="form.email" placeholder="Email (adres e-mail)*"/>
        <div class="form__row-error" v-if="errors.email"> {{ errors.email }} </div>
      </div>
      <div class="form__col-1-4 form__col--has-hint">
        <input type="password" autocomplete="false" autosuggest="false" @blur="checkPassword" v-model="form.password.first" placeholder="Hasło*"/>
        <div class="form__row-hint"> Hasło musi zawierać minimum 8 znaków w tym małą i wielką literę cyfrę i znak specjalny </div>
        <div class="form__row-error" v-if="errors.password"> {{ errors.password }} </div>
      </div>
      <div class="form__col-1-4">
        <input type="password" autocomplete="false" @blur="checkRepeatPassword" v-model="form.password.second" placeholder="Powtórz hasło*"/>
      </div>
    </div>
    <div class="form__row">
      <div class="form__col--full">
        <label class="form__checkbox-label">
          <input type="checkbox" class="form__hidden" v-model="form.regulations" @change="checkRequired('regulations')">
          <div class="checkbox checkbox--small"></div>
          <p class="form__label-content">
            *Oświadczam, że zapoznałem/łam się i akceptuję Regulamin
            <span class="form__row-error" v-if="errors.regulations"> {{ errors.regulations }} </span>
          </p>
        </label>
      </div>
    </div>
    <div class="form__row">
      <div class="form__col--full">
        <label class="form__checkbox-label">
          <input type="checkbox" class="form__hidden" v-model="form.privacy" @change="checkRequired('privacy')">
          <div class="checkbox checkbox--small"></div>
          <p class="form__label-content">
            *Wyrażam zgodę na przetwarzanie moich danych osobowych, wskazanych powyżej i podanych w trakcie rejestracji,
            przez WHITE SOLUTION <br> Sp. z o.o. Sp. k. z siedzibą w Łodzi przy ul. Traugutta 5/4 (dalej jako "Administrator"),
            w tym na umieszczenie moich danych osobowych w bazie danych Administratora oraz na ich udostępnianie podmiotom
            współpracującym z Administratorem, w zakresie niezbędnym do prawidłowej realizacji usług udostępnianych za
            pośrednictwem serwisu www.racer-online.pl w ramach projektu edukacyjnego prowadzonego przez Administratora pod nazwą
            „Racer” i w sposób zgodny z Rozporządzeniem Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r.
            w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich
            danych oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie o ochronie danych) z dnia 27 kwietnia 2016 r. Jednocześnie
            oświadczam, że zostałem poinformowany o prawie wglądu do swoich danych i możliwości żądania ich uzupełnienia,
            uaktualnienia, sprostowania oraz czasowego lub stałego wstrzymania ich przetwarzania lub ich usunięcia.
            <span class="form__row-error" v-if="errors.privacy"> {{ errors.privacy }} </span>
          </p>
        </label>
      </div>
    </div>
    <div class="form__row register__submit">
      <a @click="handleSubmit" :class="
      submitBtnClass">Zarejestruj się</a>
    </div>
  </form>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import Select from '@/components/ui/Select';

export default {
  name: "RegisterForm",
  components: {
    Select
  },
  data() {
    return {
      submitBtnClass: 'btn',
      errors: {
        "global": '',
        "firstName": '',
        "lastName": '',
        "NPWZ": '',
        "phoneNumber": '',
        "voivodeship": '',
        "city": '',
        "medicalCenter": '',
        "email": '',
        "password": '',
        "regulations": '',
        "privacy": '',
      },
      form: {
        "email": '',
        "password": {
          "first": '',
          "second": '',
        },
        "account": {
          "firstName": '',
          "lastName": '',
          "phoneNumber": '',
        },
        "specialist": {
          "NPWZ": '',
          "medicalCenter": '',
        },
        "address": {
          "voivodeship": '',
          "city": '',
        },
        "regulations": false,
        "privacy": false,
      }
    };
  },
  computed: mapGetters({
    voivodeships: 'getVoivodeships',
    registrationData: 'getRegistrationData'
  }),
  methods: {
    checkTextOnly(fieldName, parent = null, required = false) {
      this.errors[fieldName] = '';
      let formField = (parent === null) ? this.form[fieldName] : this.form[parent][fieldName];
      (!formField && required)
        ? (this.errors[fieldName] = "To pole jest wymagane")
        : !this.validTextOnly(formField)
          ? (this.errors[fieldName] = "Wprowadzono nieprawidłową wartość")
          : '';
    },
    checkNPWZ() {
      this.errors.NPWZ = '';
      !this.form.specialist.NPWZ
        ? (this.errors.NPWZ = "Numer PWZ jest wymagany")
        : (this.form.specialist.NPWZ && this.form.specialist.NPWZ.length != 7)
          ? (this.errors.NPWZ = "Numer PWZ powinien składać się z 7 cyfr")
          : !this.validNPWZ(this.form.specialist.NPWZ)
            ? (this.errors.NPWZ = "Wprowadzono nieprawidłowy numer PWZ")
            : '';
    },
    checkPhoneNumber() {
      this.errors.phoneNumber = '';
      (this.form.account.phoneNumber && !this.validPhoneNumber(this.form.account.phoneNumber))
        ? (this.errors.phoneNumber = "Wprowadzono nieprawidłowy numer telefonu")
        : '';
    },
    checkmedicalCenter() {
      this.errors.medicalCenter = '';
      (this.form.specialist.medicalCenter && this.form.specialist.medicalCenter.length < 2)
        ? (this.errors.medicalCenter = "Nazwa musi zawierać minimum dwa znaki")
        : '';
    },
    checkEmail() {
      this.errors.email = '';
      !this.form.email
        ? (this.errors.email = "Email jest wymagany")
        : !this.validEmail(this.form.email)
          ? (this.errors.email = "Podaj prawidłowy adres e-mail")
          : '';
    },
    checkPassword() {
      this.errors.password = '';
      if (!this.form.password.first) {
        this.errors.password = "Hasło jest wymagane";
      } else if (!this.validPassword(this.form.password.first)) {
        this.errors.password = "Hasło nie spełnia wymagań"
      }
    },
    checkRepeatPassword() {
      this.errors.password = '';
      if (this.form.password.first !== this.form.password.second) {
        this.errors.password = "Hasła się nie zgadzają"
      } else if (!this.validPassword(this.form.password.first) || !this.validPassword(this.form.password.first)) {
        this.errors.password = "Hasło nie spełnia wymagań"
      }
    },
    checkRequired(fieldName) {
      this.errors[fieldName] = '';
      (this.form[fieldName] === false || this.form[fieldName] === '')
        ? this.errors[fieldName] = "To pole jest wymagane"
        : '';
    },
    handleSubmit(e) {
      e.preventDefault();
      this.errors.global = '';

      this.checkEmail();
      this.checkPassword();
      this.checkRepeatPassword();
      this.checkNPWZ();
      this.checkRequired('regulations');
      this.checkRequired('privacy');
      this.checkRequired('voivodeship', 'address');
      this.checkTextOnly('firstName', 'account', true);
      this.checkTextOnly('lastName', 'account', true);
      this.checkTextOnly('city', 'address');
      this.checkTextOnly('medicalCenter', 'specialist');

      let noErrors = true;

      Object.values(this.errors).map( (el) => {
        if (el !== '') {
          noErrors = false;
        }
      })

      if (noErrors) {
        this.submitBtnClass = "btn spinner spinner--running";
        axios({
          method: 'post',
          url: `${process.env.VUE_APP_API_URL}/register`,
          data: {...this.form, registrationCode: this.registrationData.code }
        }).then( (response) => {
          this.submitBtnClass = "btn spinner spinner--complete";
          this.$store.commit('saveRegisterData', {doctorId: response.data.doctorId})
          setTimeout(() => this.$emit("complete", "registerForm"), 1000);
        }).catch( (err) => {
          this.submitBtnClass = "btn";
          this.errors.global = `Wystąpił błąd: ${err.response.data.message}`;
        });
      } else {
        this.errors.global = "Błąd walidacji formularza.";
      }
    },
    validEmail(email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    validPassword(password) {
      const re = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()\-+{}[\];:"'\\|/?<,>.])[A-Za-z\d!@#$%^&*()\-+{}[\];:"'\\|/?<,>.]{8,}$/;
      return re.test(password);
    },
    validTextOnly(text) {
      const re = /^[A-Za-zżźćńółęąśŻŹĆĄŚĘŁÓŃ ]*$/;
      return re.test(text);
    },
    validNPWZ(code) {
      let codeArray = (""+code).split("");
      const controlDigit = parseInt(codeArray[0]);
      let codeWeight = 0
      codeArray.shift();
      codeArray.map((el, i) => {
        codeWeight = codeWeight + parseInt(el) * (i+1);
      })
      return controlDigit === (codeWeight % 11)
    },
    validPhoneNumber(phoneNumber) {
      const re = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s./0-9]*$/
      return re.test(phoneNumber);
    }
  }
};
</script>

<style lang="scss">
.register {
  &__wrapper {
    width: 95%;
    max-width: 1140px;
    margin: 30px auto;
    text-align: center;
  }
  &__submit {
    justify-content: center
  }
  &__title {
    font-size: 18px;
    text-align: left;
  }
}
</style>
